import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
      user: {
        nome: '',
        cpfCnpjFormat: '',
        cpfCnpj: '',
        cdPessoa: 0
      },
      estado:'',
      errorMessageEstado: '',
      large: false,
      login: true,
      fonte: 0,
      acordos: [],
      dividas: [],
      showCardCookie: true,
      opAcordo: []
      // fonte: {
      //   soma: 0,
      //   sub: 0
      // }
    },
    mutations: {
      SET_USER (store, obj) {
        store.user = obj
      },
      SET_ESTADO (store, estado) {
        store.estado = estado
      },
      SET_ESTADO_ERROR (store, erro) {
        store.errorMessageEstado = erro
      },
      SET_TELA (store, large) {
        store.large = large
      },
      SET_LOGIN (store, login) {
        store.login = login
      },
      SET_FONTE (store, fonte) {
        store.fonte = fonte
      },
      SET_ACORDOS (store, acordos) {
        store.acordos = acordos
      },
      SET_DIVIDAS (store, dividas) {
        store.dividas = dividas
      },
      SET_CARD_COOKIE (store, showCard) {
        store.showCardCookie = showCard
      },
      SET_OP_ACORDO (store, opAcordo) {
        store.opAcordo = opAcordo
      }
      
    }
  })